import {SelectedCarrierServiceOption} from '@wix/auto_sdk_ecom_current-cart';
import {DeliveryMethodModel} from './DeliveryMethod.model';

export class DeliverySummaryModel {
  public method?: DeliveryMethodModel;

  constructor(params: DeliverySummaryModel) {
    this.method = params.method;
  }

  public static fromCartV1(selectedShippingOption?: SelectedCarrierServiceOption) {
    return new DeliverySummaryModel({
      method: DeliveryMethodModel.fromCartV1(selectedShippingOption),
    });
  }
}
